// IDs and codes identify records; neither substitutes for a location's name.
// Keep unresolved labels explicit without changing the selected ID or permissions.
export function getLocationName(location, languageId = "en") {
  const name = typeof location?.name === "string" ? location.name.trim() : "";
  return name || (languageId === "es" ? "Nombre de ubicación no disponible" : "Location name unavailable");
}
